export default {
  // Data in News page
  GET_DATA_BLOG_PAGE: state => {
    const data = state.blogPage
    return {
      filters: data.filters,
      posts: data.posts,
      lastAddedPosts: data.lastAddedPosts,
      limit: data.limit
    }
  },

  // Data in Test Drive Simple car page
  GET_SECTIONS_SIMPLE_PAGE: state => {
    const data = state.simplePage
    return data && data.sections
  },

  GET_MAIN_DATA_SIMPLE_PAGE: state => {
    const data = state.simplePage
    let categoryId = null
    let categoryName = ''
    let categoryUrlName = ''
    
    state.category.forEach((item) => {
      if (item.id == data.category_id) {
        categoryId = item.id
        categoryName = item.title
        categoryUrlName = item.url
      }
    })
    
    return {
      img: data.img && data.img.file_name,
      title: data.title,
      date: data.created,
      author: data.author,
      categoryId: categoryId,
      category: categoryName,
      categoryUrlName: categoryUrlName,
      car: data && data.car,
      subCategory:data.sub_category && data.sub_category.name
    }
  },

  GET_SIMILAR_POSTS: state => {
    return state.simplePage.similar
  }
}
